module.exports = __webpack_public_path__ + "img/mail.d5f31275.svg";